import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

const propTypes = {
  primary: PropTypes.bool,
};
const defaultProps = {
  primary: false,
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const Spinner = styled.div`
  position: absolute;
  left: calc(50% - 12px);
  top: calc(50% - 12px);
  border: 3px solid ${props => (props.primary ? 'white' : props.theme.color_theme)};
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`;

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
export default Spinner;
